/**
 * The single, platform-wide money formatter. Use this everywhere a currency
 * amount is rendered (tenant-web, rr-admin, portals, books, backend presenters).
 * Do not hand-roll `Intl.NumberFormat` / `toLocaleString` with `style: 'currency'`
 * or hardcoded `$`/`€` prefixes — extend this function instead.
 *
 * Style is always **amount, one space, currency code**: `500 USD`, `1,200 EUR`,
 * `900 TMT`. No currency symbols — the code is the single, unambiguous form and
 * works for every currency including ones Intl doesn't recognise (TMT etc.).
 */
export function formatAmount(value, { currency = "USD", showCode = true, showSign = false, decimals, compact = false } = {}) {
    const abs = Math.abs(value);
    const d = decimals ?? (compact ? 1 : 0);
    const formatted = new Intl.NumberFormat("en-US", {
        notation: compact ? "compact" : "standard",
        minimumFractionDigits: compact ? 0 : d,
        maximumFractionDigits: d,
    }).format(abs);
    const code = showCode ? ` ${currency}` : "";
    const sign = showSign ? (value >= 0 ? "+" : "−") : value < 0 ? "−" : "";
    return `${sign}${formatted}${code}`;
}
//# sourceMappingURL=currency.js.map